<template>
  <div class="cigar-list">
    <UploadCustomize id="1" />
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="雪茄名称：">
          <el-input
            type="text"
            v-model="form.cigarName"
            @input="handleInputChange"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" v-if="isShowBatch" @click="handleConfig"
            >批量设置</el-button
          >
          <el-button
            type="success"
            v-if="!isShowBatch"
            @click="handleBatchShelves(1)"
            >批量上架</el-button
          >
          <el-button
            type="success"
            v-if="!isShowBatch"
            @click="handleBatchShelves(0)"
            >批量下架</el-button
          >
          <el-button type="primary" @click="handleExport">导出</el-button>
          <el-button type="primary" @click="handleAdd">添加商品</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @select="handleSingleChange"
        @select-all="handleAllchange"
      >
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column label="排序" type="index"></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.cigarUrl" alt class="memberImg" />
          </template>
        </el-table-column>
        <el-table-column
          prop="cigarName"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="brandName"
          label="品牌"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="seriesName"
          label="系列"
          align="center"
        ></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.cigarState"
              @click="handleShelves(scope.row.id, 1)"
              >上架</span
            >
            <span v-else @click="handleShelves(scope.row.id, 0)">下架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="150px">
          <template slot-scope="scope">
            <span
              class="upShelves"
              v-if="!scope.row.cigarState"
              @click="handleShelves(scope.row.id, 1)"
              >上架</span
            >
            <span
              class="downShelves"
              v-else
              @click="handleShelves(scope.row.id, 0)"
              >下架</span
            >
            <span class="view" @click="handlePreview(scope.row)">预览</span>
            <el-popover
              popper-class="wechatCode"
              placement="top"
              width="60"
              trigger="click"
            >
              <img :src="scope.row.cigarQrCode" alt class="wechatImg" />
              <span class="wechat" slot="reference">小程序码</span>
            </el-popover>
            <span class="del" @click="handleDel(scope.row.id)">删除</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
            <span class="path" @click="openDialog(scope.row.cigarPath)"
              >路径配置</span
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <copyDialog
      :visible="visible"
      :configPath="path"
      @close="visible = false"
    />
    <Preview
      :visible="previewVisible"
      :selectId="currentCellId"
      @close="handleClosePreview"
    />
  </div>
</template>
<script>
import {
  getCigarList,
  updateCigarUpAndDown,
  deleteCigar,
  exportCigar,
} from '@/api/goods';
import Preview from '@/components/h5/cigarPage.vue';
import Pagination from '@/components/Pagination';
import copyDialog from '@/components/copyDialog';
import batch from '@/mixins/batch';
import Excel from '@/mixins/export';
import preview from '@/mixins/mobile';
import UploadCustomize from '../components/UploadCustomize.vue';

export default {
  mixins: [batch, Excel, preview],
  name: 'CigarList',
  data() {
    return {
      path: '',
      form: {
        cigarName: '',
      },
      tableData: [],
      visible: false,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Pagination,
    copyDialog,
    Preview,
    UploadCustomize,
  },
  created() {
    this.handleInputChange = this.$debounce(this.handleInputChange, 500, {
      leading: false,
      trailing: true,
    });
  },
  mounted() {
    this.getCigarList();
  },
  methods: {
    getCigarList() {
      this.loading = true;
      return getCigarList({
        cigarName: this.form.cigarName,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
        } else {
          this.$message.error(res.message);
        }
        return false;
      });
    },
    updateCigarUpAndDown(ids, cigarState) {
      updateCigarUpAndDown(ids, cigarState).then((res) => {
        if (res.success) {
          this.getCigarList();
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getCigarList();
    },
    // 导出
    handleExport() {
      exportCigar(this.form.cigarName).then((res) => {
        this.exportExcel(res, '雪茄列表');
      });
    },
    // 单个上下架
    handleShelves(id, cigarState) {
      this.updateCigarUpAndDown(id, cigarState);
    },
    // 批量上下架
    handleBatchShelves(cigarState) {
      const tempArr = this.getDealArr();
      if (tempArr.length > 0) {
        this.updateCigarUpAndDown(tempArr, cigarState);
        this.clearSelection();
      } else {
        this.$message.warning('请选择需要至少一条数据后操作！');
      }
    },
    // 删除
    handleDel(id) {
      deleteCigar(id).then((res) => {
        if (res.success) {
          this.getCigarList();
          this.$message.success('删除成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取页面路径
    openDialog(value) {
      this.path = value;
      this.visible = true;
    },
    // 分页
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getCigarList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getCigarList().then((res) => {
        if (res) {
          this.findSelectionItem(res);
        }
      });
    },
    // 添加商品
    handleAdd() {
      this.$router.push({ name: 'CigarAdd' });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'CigarEditor',
        query: {
          id,
        },
      });
    },
    // 预览
    handleView() {},
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.view, .del, .editor, .path, .upShelves, .downShelves, .wechat
  color #1890ff
  cursor pointer
.view, .del, .editor, .upShelves, .downShelves, .wechat
  margin-right 20px
.memberImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
